import { useEffect, useState } from 'react';
import { obtieneFuentesSiniestro } from '../../services/Siniestro/SiniestroService';
import {
    listarArchivosFuente,
    descargarOAbrirArchivo
} from '../../services/Siniestro/SiniestroFuenteArchivoService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

const ListaFuentes = ({ datosSin }) => {
    const [lstFuentes, setLstFuentes] = useState([]);
    const [cargaFuentes, setCargaFuentes] = useState(false);
    const [expandedRows, setExpandedRows] = useState(null);
    /** mapa { fuenteId: { cargando, archivos } } */
    const [archivosPorFuente, setArchivosPorFuente] = useState({});

    useEffect(() => {
        const recobraFuentes = async () => {
            try {
                setCargaFuentes(true);
                const datos = await obtieneFuentesSiniestro(datosSin.siniestroId);
                setLstFuentes(datos);
            } catch (error) {
                console.error('ERROR: Error al cargar Fuentes');
            } finally {
                setCargaFuentes(false);
            }
        };
        recobraFuentes();
    }, [datosSin.siniestroId]);

    const cargarArchivosDeFuente = async (siniestroFuenteId) => {
        // Si ya esta cargado, no recargar
        if (archivosPorFuente[siniestroFuenteId]?.archivos !== undefined) return;
        setArchivosPorFuente((prev) => ({
            ...prev,
            [siniestroFuenteId]: { cargando: true, archivos: [] }
        }));
        try {
            const arch = await listarArchivosFuente(siniestroFuenteId);
            setArchivosPorFuente((prev) => ({
                ...prev,
                [siniestroFuenteId]: { cargando: false, archivos: arch || [] }
            }));
        } catch (e) {
            setArchivosPorFuente((prev) => ({
                ...prev,
                [siniestroFuenteId]: { cargando: false, archivos: [] }
            }));
        }
    };

    const onRowToggle = (e) => {
        setExpandedRows(e.data);
        const idsAbiertos = Object.keys(e.data || {});
        idsAbiertos.forEach((id) => {
            const fila = lstFuentes.find((f) => String(f.siniestroFuenteId) === String(id));
            if (fila) cargarArchivosDeFuente(fila.siniestroFuenteId);
        });
    };

    const bodyLink = (rowData) => {
        if (!rowData.link) return <span className="text-color-secondary">—</span>;
        return (
            <a href={rowData.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                {rowData.link}
            </a>
        );
    };

    const fmtTamano = (bytes) => {
        if (!bytes && bytes !== 0) return '';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };

    const iconoPorTipo = (mime) => {
        const m = (mime || '').toLowerCase();
        if (m === 'application/pdf') return 'pi pi-file-pdf text-red-500';
        if (m.startsWith('image/')) return 'pi pi-image text-blue-500';
        return 'pi pi-file';
    };

    const handleVer = async (archivo) => {
        try {
            await descargarOAbrirArchivo(archivo);
        } catch (e) {
            console.error('No se pudo abrir el archivo', e);
        }
    };

    const expansionTemplate = (rowData) => {
        const data = archivosPorFuente[rowData.siniestroFuenteId];
        return (
            <div className="px-4 py-2 surface-50 border-round">
                <div className="font-medium mb-2"><i className="pi pi-paperclip mr-2"></i>Archivos adjuntos</div>
                {!data || data.cargando ? (
                    <div className="flex align-items-center gap-2">
                        <ProgressSpinner style={{ width: '20px', height: '20px' }} />
                        <span className="text-color-secondary text-sm">Cargando archivos...</span>
                    </div>
                ) : data.archivos.length === 0 ? (
                    <div className="text-color-secondary text-sm">Sin archivos adjuntos en esta fuente.</div>
                ) : (
                    <ul className="list-none p-0 m-0">
                        {data.archivos.map((a) => (
                            <li
                                key={a.siniestroFuenteArchivoId}
                                className="flex align-items-center justify-content-between border-bottom-1 border-200 py-2"
                            >
                                <div className="flex align-items-center gap-2">
                                    <i className={iconoPorTipo(a.tipoMime)} style={{ fontSize: '1.4rem' }}></i>
                                    <div>
                                        <div className="font-medium">{a.nombreArchivo}</div>
                                        <div className="text-sm text-color-secondary">
                                            {a.tipoMime} · {fmtTamano(a.tamanoBytes)}
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    icon="pi pi-download"
                                    label="Ver / Descargar"
                                    className="p-button-text"
                                    onClick={() => handleVer(a)}
                                />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    };

    return (
        <div className="card">
            <h6>Lista de Fuentes</h6>
            <DataTable
                value={lstFuentes}
                showGridlines
                size="small"
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25]}
                responsiveLayout="scroll"
                loading={cargaFuentes}
                expandedRows={expandedRows}
                onRowToggle={onRowToggle}
                rowExpansionTemplate={expansionTemplate}
                dataKey="siniestroFuenteId"
            >
                <Column expander style={{ width: '3em' }} />
                <Column header="Nombre" field="fuente" />
                <Column header="Descripcion" field="descripcion" />
                <Column header="Link" body={bodyLink} />
            </DataTable>
        </div>
    );
};

export default ListaFuentes;
